import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { C4ListResponse, ProjectDTO, RestService } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { UrlService } from '@service/url/url.service';
import { MtxPopoverTrigger } from '@ng-matero/extensions/popover';

@Component({
	selector: 'app-project-selector',
	templateUrl: './project-selector.component.html',
	styleUrls: ['./project-selector.component.scss'],
})
export class ProjectSelectorComponent implements OnInit {
	@Input() accountId: number;
	@Input() labelAlignment: string = 'center center';

	@Output() projectSelectedEvent: EventEmitter<ProjectDTO> = new EventEmitter();
	@ViewChild(MtxPopoverTrigger) trigger: MtxPopoverTrigger;

	searchText;
	projects: Array<ProjectDTO> = null;
	selectedProject: ProjectDTO = null;
	hasNextPage: boolean = false;
	isLoadingProjectsList: boolean = false;
	page = 0;
	pageSize = 20;

	constructor(
		public utilService: UtilService,
		private restService: RestService,
		private urlService: UrlService
	) {}

	ngOnInit() {
		this.getProjects();
	}

	viewMoreProjects() {
		this.page += 1;
		this.getProjects();
	}

	getProjects() {
		this.isLoadingProjectsList = true;
		const request = {
			accountId: this.accountId,
			page: this.page,
			pageSize: this.pageSize,
			sortColumn: 'created',
			sortOrder: 'desc',
		};
		const url = this.urlService.getProjectsList();
		this.restService.POST(url, request).subscribe(
			(response: C4ListResponse<ProjectDTO>) => {
				if (this.projects) {
					this.projects = this.projects.concat(response.data);
				} else {
					this.projects = response.data;
				}
				this.hasNextPage = response.nextPage;
				this.isLoadingProjectsList = false;
			},
			(error) => {
				this.projects = [];
				this.isLoadingProjectsList = false;
			}
		);
	}

	projectSelected(project: ProjectDTO) {
		this.selectedProject = project;
		this.projectSelectedEvent.emit(project);
		this.trigger.closePopover();
	}

	projectCleared() {
		this.selectedProject = null;
		this.projectSelectedEvent.emit(null);
	}
}
